import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { usePathname } from "@lib/i18n/navigation-app-router";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import StoryblokImage from "@components/core/Storyblok/StoryblokImage";
import Button from "@components/core/Button";

function HomeCollectionList3({ blok }) {
  const pathname = usePathname();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  function sendTrackerData(collectionTitle, collectionLink) {
    const defaultEventData = {
      tracking_name: "homeCollectionList3",
      page: pathname,
      collection_title: collectionTitle,
      collection_link: collectionLink,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  function renderCollectionCards() {
    return [0, 1, 2].map((index) => {
      const i = index + 1;
      const title = blok[`collection_title_${i}`];
      const link = blok[`collection_link_${i}`]?.url;
      const image = blok[`collection_image_${i}`]?.filename;

      return (
        <section
          className="collection-list-3-card"
          key={`collection_id_${i}`}
        >
          <Link
            href={link}
            prefetch={false}
            onClick={() => sendTrackerData(title, link)}
            className="collection-list-3-link"
          >
            <StoryblokImage
              className="collection-list-3-image"
              alt={title}
              src={image}
              sizes="(min-width: 768px) 33vw, 80vw"
            />
            <div className="collection-list-3-btn-container">
              <Button variant="ghost-primary">{title}</Button>
            </div>
          </Link>
          <h6 className="collection-list-3-title">{title}</h6>
        </section>
      );
    });
  }

  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="storyblok-home-section"
    >
      <div className="collection-list-3-container">{renderCollectionCards()}</div>
    </section>
  );
}

export default HomeCollectionList3;
